<div class="loader" *ngIf="isLoading" id="loader">
  <div class="loaderImg"><img src="./assets/images/loading.gif" alt="" /></div>
</div>

<div class="state_page_banner videoBannerGlobal" *ngIf="resultContent.name;else banner_video_skeleton">
  <video *ngIf="resultContent.video != null" #videoElement width="100%" id="main-video"
    class="video-playing embed-responsive-item" loop muted autoplay playsinline oncanplay="this.play()"
    onloadedmetadata="this.muted = true" [poster]="main_image_url+resultContent.image">
    <source id="source_mp4" [src]="main_image_url+resultContent.video" type="video/mp4"
      *ngIf="resultContent.video != null">
  </video>
  <img *ngIf="resultContent.video == null" [src]="main_image_url+resultContent.image"
    alt="{{resultContent.alt_text_image}}" />
  <h1 class="d-none">{{resultContent?.h1_tag}}</h1>
  <div class="state_page_banner_name">{{ resultContent?.name }}</div>
</div>
<ng-template #banner_video_skeleton>
  <ngx-skeleton-loader count="14" appearance="line"></ngx-skeleton-loader>
</ng-template>

<div class="container" *ngIf="resultContent.type == 'country-list' && resultContent.description">
  <div class="row">
    <div class="col-12">
      <div class="giftHead">
        <h2 class="hclass">ABOUT {{ resultContent?.name }}</h2>
        <p [innerHTML]="resultContent?.description | appendDollar">
        </p>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="bread-crumbs">
    <!-- Home Breadcrumb -->
    <div class="bread_crumbs">
      <a [routerLink]="['/']">{{ "Home" }}</a> &gt;
    </div>

    <!-- Parent Location Breadcrumb, if available -->
    <div class="bread_crumbs" *ngIf="resultContent.parent_location_slug != '' && resultContent.parent_location_slug != null && 
         resultContent.parent_location_name != '' && resultContent.parent_location_name != null">
      <a [routerLink]="['/location-region', resultContent.parent_location_slug]">
        {{ resultContent?.parent_location_name }}
      </a> &gt;
    </div>

    <!-- Current Location (Active) Breadcrumb -->
    <div class="bread_crumbs">
      <span [class.is_breadcrumb_active]="true">
        {{ resultContent?.name | titlecase }}
      </span>
    </div>
  </div>
</div>
<!-- ------------------------ filter group  -->
<div class="searchGift">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="home_searchInner only_mobView" data-toggle="modal" data-target="#homeModalFilter">
          <div class="search_placeBox set-search-box-icon pb-0 border-none-mobile">
            <div class="location-icon">
              <svg width="23" height="29" viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.2188 11.5938C20.2187 9.28139 19.3002 7.06375 17.6651 5.42866C16.03 3.79358 13.8124 2.875 11.5 2.875C9.18764 2.875 6.97 3.79358 5.33491 5.42866C3.69983 7.06375 2.78125 9.28139 2.78125 11.5938C2.78125 15.1704 5.64294 19.832 11.5 25.4159C17.3571 19.832 20.2188 15.1704 20.2188 11.5938ZM11.5 28.0625C4.39519 21.6048 0.84375 16.1139 0.84375 11.5938C0.84375 8.76754 1.96646 6.05708 3.96489 4.05864C5.96333 2.06021 8.67379 0.9375 11.5 0.9375C14.3262 0.9375 17.0367 2.06021 19.0351 4.05864C21.0335 6.05708 22.1562 8.76754 22.1562 11.5938C22.1562 16.1139 18.6048 21.6048 11.5 28.0625Z"
                  fill="black" />
                <path
                  d="M11.5 14.5C12.2708 14.5 13.01 14.1938 13.555 13.6488C14.1001 13.1038 14.4062 12.3645 14.4062 11.5938C14.4062 10.823 14.1001 10.0837 13.555 9.53872C13.01 8.99369 12.2708 8.6875 11.5 8.6875C10.7292 8.6875 9.99 8.99369 9.44497 9.53872C8.89994 10.0837 8.59375 10.823 8.59375 11.5938C8.59375 12.3645 8.89994 13.1038 9.44497 13.6488C9.99 14.1938 10.7292 14.5 11.5 14.5ZM11.5 16.4375C10.2154 16.4375 8.98333 15.9272 8.07495 15.0188C7.16657 14.1104 6.65625 12.8784 6.65625 11.5938C6.65625 10.3091 7.16657 9.07708 8.07495 8.1687C8.98333 7.26032 10.2154 6.75 11.5 6.75C12.7846 6.75 14.0167 7.26032 14.925 8.1687C15.8334 9.07708 16.3438 10.3091 16.3438 11.5938C16.3438 12.8784 15.8334 14.1104 14.925 15.0188C14.0167 15.9272 12.7846 16.4375 11.5 16.4375Z"
                  fill="black" />
              </svg>
            </div>
            <div>
              <label class="search_placeLable">Where To?</label>
              <div class="mobileClick_filter"></div>
            </div>
          </div>
        </div>
        <div class="home_searchInner only_dstView">
          <div class="search_placeBox set-search-box-icon">
            <div class="location-icon">
              <svg width="23" height="29" viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.2188 11.5938C20.2187 9.28139 19.3002 7.06375 17.6651 5.42866C16.03 3.79358 13.8124 2.875 11.5 2.875C9.18764 2.875 6.97 3.79358 5.33491 5.42866C3.69983 7.06375 2.78125 9.28139 2.78125 11.5938C2.78125 15.1704 5.64294 19.832 11.5 25.4159C17.3571 19.832 20.2188 15.1704 20.2188 11.5938ZM11.5 28.0625C4.39519 21.6048 0.84375 16.1139 0.84375 11.5938C0.84375 8.76754 1.96646 6.05708 3.96489 4.05864C5.96333 2.06021 8.67379 0.9375 11.5 0.9375C14.3262 0.9375 17.0367 2.06021 19.0351 4.05864C21.0335 6.05708 22.1562 8.76754 22.1562 11.5938C22.1562 16.1139 18.6048 21.6048 11.5 28.0625Z"
                  fill="black" />
                <path
                  d="M11.5 14.5C12.2708 14.5 13.01 14.1938 13.555 13.6488C14.1001 13.1038 14.4062 12.3645 14.4062 11.5938C14.4062 10.823 14.1001 10.0837 13.555 9.53872C13.01 8.99369 12.2708 8.6875 11.5 8.6875C10.7292 8.6875 9.99 8.99369 9.44497 9.53872C8.89994 10.0837 8.59375 10.823 8.59375 11.5938C8.59375 12.3645 8.89994 13.1038 9.44497 13.6488C9.99 14.1938 10.7292 14.5 11.5 14.5ZM11.5 16.4375C10.2154 16.4375 8.98333 15.9272 8.07495 15.0188C7.16657 14.1104 6.65625 12.8784 6.65625 11.5938C6.65625 10.3091 7.16657 9.07708 8.07495 8.1687C8.98333 7.26032 10.2154 6.75 11.5 6.75C12.7846 6.75 14.0167 7.26032 14.925 8.1687C15.8334 9.07708 16.3438 10.3091 16.3438 11.5938C16.3438 12.8784 15.8334 14.1104 14.925 15.0188C14.0167 15.9272 12.7846 16.4375 11.5 16.4375Z"
                  fill="black" />
              </svg>
            </div>
            <div class="search-box-content w-100">
              <label class="search_placeLable">Where To?</label>
              <div class="input_boxSearch search_show_box">
                <div class="primeAutocomplete homeAutoCompCountryParent homeSerachWidth">
                  <p-autoComplete #autoCompleteRef emptyMessage="No records found." (onClear)="clear_searched_data()"
                    [suggestions]="autocompleteExpResults" (completeMethod)="autocompleteSearchData($event)"
                    placeholder="{{title_search ? title_search : 'Search for a place or experience'}}"
                    (onSelect)="onSelectAutocompleteSearch($event.value);" field="label" 
                    (onFocus)="onFocusSearchBox($event)" (onBlur)="onBlurSearchBox($event)"
                    (input)="searchedInput($event)" [style]="{'width':'100%'}" [inputStyle]="{'width':'100%'}"
                    id="autoCompleteSearchValue">
                    <ng-template let-country pTemplate="item">
                      <div class="country-item homeCountyAutoComplete">
                        <div class="location-icons-photo">
                          @if(country?.type == 'location'){
                          <img [src]="country?.image_url" class="flag" />
                          }

                          <img *ngIf="country?.type == 'exp' || country?.type == 'category'"
                            [src]="(country?.type == 'exp') ? exp_image_url + country?.image : ((country?.type == 'category') ? category_image_url + country?.image : location_image_url + country.image )"
                            class="flag" />
                        </div>

                        <div class="countryLabelHomeparent text-left">
                          <div class="countryLabelHome">{{country?.label}}</div>
                          <div class="countryLabelAddress" *ngIf="country?.type == 'exp'">
                            {{country?.city_name}} , {{country?.state_name}}
                          </div>
                          <div class="countryLabelprice" *ngIf="country.type == 'location'">
                            <span>(Location)</span>
                          </div>
                          <div class="countryLabelprice"
                            *ngIf="country?.type == 'exp' && country?.experience_type == 1">
                            ${{country?.exp_price | priceFormat}}
                            <span>
                              &#123; {{country?.price_label}} &#125;
                            </span>
                          </div>
                          <div class="countryLabelprice"
                            *ngIf="country?.type == 'exp' && country?.experience_type == 2">
                            ANY PRICE
                          </div>
                        </div>

                      </div>
                    </ng-template>
                  </p-autoComplete>

                  <!-- Recent searches dropdown -->
                  <div class="recent-searches-dropdown" *ngIf="showRecentSearches">
                    <ul>
                      <li (click)="nearby(false)">
                        <div class="location-icons-photo">
                          <svg xmlns="http://www.w3.org/2000/svg" version="1.1"
                            xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0"
                            viewBox="0 0 32 32" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                            <g>
                              <path
                                d="M28.707 3.293a.997.997 0 0 0-1.123-.202l-24 11a1 1 0 0 0 .333 1.906l11.157.93.93 11.156a1 1 0 0 0 1.906.334l11-24a1 1 0 0 0-.203-1.124zM17.68 24.117l-.683-8.2a1 1 0 0 0-.914-.914l-8.2-.683L25.97 6.03z"
                                fill="#000000" opacity="1" data-original="#000000" class="">
                              </path>
                            </g>
                          </svg>

                        </div>
                        <div class="locationName">
                          Nearby
                        </div>
                      </li>
                    </ul>

                    <div class="search-reset" *ngIf="searchHistory?.length">
                      <div class="recents">Recent Searches</div>
                      <div class="recents-clear"><a (click)="clearRecentSearch()" href="javascript:void(0)">Clear</a>
                      </div>
                    </div>
                    <ul *ngIf="searchHistory?.length">
                      <ul>
                        <li *ngFor="let search of searchHistory" (click)="selectRecentSearch(search);">
                          <div class="location-icons-photo">
                            <svg *ngIf="search?.type == 'location-list'" width="23" height="29" viewBox="0 0 23 29"
                              fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M20.2188 11.5938C20.2187 9.28139 19.3002 7.06375 17.6651 5.42866C16.03 3.79358 13.8124 2.875 11.5 2.875C9.18764 2.875 6.97 3.79358 5.33491 5.42866C3.69983 7.06375 2.78125 9.28139 2.78125 11.5938C2.78125 15.1704 5.64294 19.832 11.5 25.4159C17.3571 19.832 20.2188 15.1704 20.2188 11.5938ZM11.5 28.0625C4.39519 21.6048 0.84375 16.1139 0.84375 11.5938C0.84375 8.76754 1.96646 6.05708 3.96489 4.05864C5.96333 2.06021 8.67379 0.9375 11.5 0.9375C14.3262 0.9375 17.0367 2.06021 19.0351 4.05864C21.0335 6.05708 22.1562 8.76754 22.1562 11.5938C22.1562 16.1139 18.6048 21.6048 11.5 28.0625Z"
                                fill="black" />
                              <path
                                d="M11.5 14.5C12.2708 14.5 13.01 14.1938 13.555 13.6488C14.1001 13.1038 14.4062 12.3645 14.4062 11.5938C14.4062 10.823 14.1001 10.0837 13.555 9.53872C13.01 8.99369 12.2708 8.6875 11.5 8.6875C10.7292 8.6875 9.99 8.99369 9.44497 9.53872C8.89994 10.0837 8.59375 10.823 8.59375 11.5938C8.59375 12.3645 8.89994 13.1038 9.44497 13.6488C9.99 14.1938 10.7292 14.5 11.5 14.5ZM11.5 16.4375C10.2154 16.4375 8.98333 15.9272 8.07495 15.0188C7.16657 14.1104 6.65625 12.8784 6.65625 11.5938C6.65625 10.3091 7.16657 9.07708 8.07495 8.1687C8.98333 7.26032 10.2154 6.75 11.5 6.75C12.7846 6.75 14.0167 7.26032 14.925 8.1687C15.8334 9.07708 16.3438 10.3091 16.3438 11.5938C16.3438 12.8784 15.8334 14.1104 14.925 15.0188C14.0167 15.9272 12.7846 16.4375 11.5 16.4375Z"
                                fill="black" />
                            </svg>

                            <img [src]="search.image_url" *ngIf="search?.type == 'exp'" class="img-fluid search-img" />
                            <img [src]="search.image_url" *ngIf="search?.type == 'higher-level-category'" class="img-fluid search-img" />
                            <svg width="800px" *ngIf="search?.type == 'category'" height="800px" viewBox="0 0 24 24"
                              id="_24x24_On_Light_Recent" data-name="24x24/On Light/Recent"
                              xmlns="http://www.w3.org/2000/svg">
                              <rect id="view-box" width="24" height="24" fill="none" />
                              <path id="Shape"
                                d="M9.682,18.75a.75.75,0,0,1,.75-.75,8.25,8.25,0,1,0-6.189-2.795V12.568a.75.75,0,0,1,1.5,0v4.243a.75.75,0,0,1-.751.75H.75a.75.75,0,0,1,0-1.5H3a9.75,9.75,0,1,1,7.433,3.44A.75.75,0,0,1,9.682,18.75Zm2.875-4.814L9.9,11.281a.754.754,0,0,1-.22-.531V5.55a.75.75,0,1,1,1.5,0v4.889l2.436,2.436a.75.75,0,1,1-1.061,1.06Z"
                                transform="translate(1.568 2.25)" fill="#141124" />
                            </svg>
                          </div>
                          <div class="location-infos">
                            <span class="product-name">{{search?.title}}
                            </span><br>
                            <span class="cityName" *ngIf="search.city">{{search.city ?
                              '('+search.city+')' : ''}}</span>

                            <span class="cityName" *ngIf="search.location_type">{{search.location_type == 2 ?
                              '(City)' : search.location_type == 'location-list' ? '(State)' : ''}}</span>
                          </div>

                        </li>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="search_placeBox">

            <!-- this is for open date picker => [isOpen]="isOpenDatePicker" -->
            <label class="search_placeLable">When? (optional) </label>
            <div class="input_boxSearch">
              <div class="selectDataBlock" *ngIf="!isMobile">
                <input type="text" bsDaterangepicker placeholder="" [dateCustomClasses]="dateCustomClasses"
                  placement="bottom left" [outsideClick]="true" class="date_pickerFont"
                  [bsConfig]="{showWeekNumbers:false, dateInputFormat: 'YYYY/MM/DD',displayMonths :1}"
                  [minDate]="minDate" [maxDate]="maxDate" placeholder="Select dates"
                  (bsValueChange)="chooseMethodTocall($event)" (onShown)="onShowPicker($event)" readonly="readonly"
                  [(ngModel)]="selectedDateRange" />
                <a class="dataClear" (click)="clearDate()" *ngIf="selectedDateRange?.length"
                  href="javascript:void(0); ">
                  <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.8125 3.81227C4.04691 3.57793 4.36479 3.44629 4.69625 3.44629C5.02771 3.44629 5.34559 3.57793 5.58 3.81227L10 8.23227L14.42 3.81227C14.6558 3.58457 14.9715 3.45858 15.2993 3.46143C15.627 3.46428 15.9405 3.59574 16.1723 3.8275C16.404 4.05926 16.5355 4.37277 16.5383 4.70052C16.5412 5.02827 16.4152 5.34402 16.1875 5.57977L11.7675 9.99977L16.1875 14.4198C16.4152 14.6555 16.5412 14.9713 16.5383 15.299C16.5355 15.6268 16.404 15.9403 16.1723 16.172C15.9405 16.4038 15.627 16.5353 15.2993 16.5381C14.9715 16.541 14.6558 16.415 14.42 16.1873L10 11.7673L5.58 16.1873C5.34425 16.415 5.02849 16.541 4.70075 16.5381C4.373 16.5353 4.05949 16.4038 3.82773 16.172C3.59597 15.9403 3.46451 15.6268 3.46166 15.299C3.45881 14.9713 3.5848 14.6555 3.8125 14.4198L8.2325 9.99977L3.8125 5.57977C3.57816 5.34536 3.44652 5.02748 3.44652 4.69602C3.44652 4.36457 3.57816 4.04668 3.8125 3.81227Z"
                      fill="#25324B" />
                  </svg>

                </a>
              </div>
            </div>
          </div>
          <div class="search_homeBtn">
            <button class="primeSeachBox prime_active"
              (click)="onSelectAutocompleteLocation(autocomplete_search_to, false)">
              <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="search" role="img"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search fa-w-16">
                <path fill="#fff"
                  d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
                  class=""></path>
              </svg>

              <span class="d-md-none">Search</span>
            </button>
          </div>
        </div>

        <!-- </ul>
          </div>
        </form> -->


      </div>
    </div>
  </div>

</div>

<!-- content list-->
<div class="city-list-box d-none d-lg-block" *ngIf="locationContent?.length > 0">
  <div class="container">
    <div class="city_headBox input_titleIcon">
      <h3 class="m-0">{{ displayState ? 'States' : 'Cities' }} in {{resultContent?.name}} {{resultContent?.image_url}}
      </h3>
      <div class="input_searchIcon">
        <input type="text" class="form-control search-box-radius" placeholder="Search"
          (input)="filterContent($event.target.value)">
        <button type="button" class="input_iconPosition">
          <svg width="17" height="19" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="search"
            role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="#000"
              d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z">
            </path>
          </svg>
        </button>
      </div>
    </div>
    <div *ngIf="displayedContent.length > 0; else noDataTemplate">
      <div class="row g-3">
        <div class="col-lg-3 col-md-4" *ngFor="let city of displayedContent">
          <a href="javascript:void(0)" routerLink="/location-region/{{slug}}/{{city?.slug}}"
            (click)="selected_content($event,city.slug)">
            <div class="city-card card_expBanner cursor-pointer">
              <img [src]="imageUrl+ city.image" [alt]="city.name" style="cursor: pointer;">
              <div class="city-name" style="cursor: pointer;">{{ city.name }}</div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <ng-template #noDataTemplate>
      <div class="no-data-found">
        No record found
      </div>
    </ng-template>
  </div>
</div>

<!-- content list mobile-->
<div class="city-list-box  d-block d-lg-none " *ngIf="locationContent?.length > 0">
  <div class="container">
    <div class="city_headBox input_titleIcon">
      <h3 class="m-0">{{ displayState ? 'States' : 'Cities' }} in {{resultContent?.name}} {{resultContent?.image_url}}
      </h3>
      <div class="input_searchIcon">
        <input type="text" class="form-control search-box-radius" placeholder="Search"
          (input)="filterContent($event.target.value)">
        <button type="button" class="input_iconPosition">
          <svg width="17" height="19" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="search"
            role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path fill="#000"
              d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z">
            </path>
          </svg>
        </button>
      </div>
    </div>
    <div *ngIf="displayedContent.length > 0; else noDataTemplate" class="mobile-city-list">
      <div class="container px-0">
        <drag-scroll #nav [scroll-x-wheel-enabled]="true">
          <div class="drag-scroll-item" *ngFor="let city of displayedContent; let i = index" drag-scroll-item>
            <a href="javascript:void(0)" routerLink="/location-region/{{slug}}/{{city?.slug}}"
              (click)="selected_content($event,city.slug)">
              <div class="city-card card_expBanner cursor-pointer">
                <img [src]="imageUrl + city.image" [alt]="city.name" class="city-image">
                <div class="city-name">{{ city.name }}</div>
              </div>
            </a>
          </div>
        </drag-scroll>
      </div>
    </div>

    <ng-template #noDataTemplate>
      <div class="no-data-found">
        No record found
      </div>
    </ng-template>
  </div>
</div>

<!--   all experience category --------------- -->
<div class="exptravelCategory">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="text-center mb-4">
          <div class="search-list-box">
            <label class="exploreTxt">ALL EXPERIENCES</label>
            <div class="form-group category_name position-relative">
              <p-autoComplete [suggestions]="filteredGroups" [group]="true" [virtualScroll]="true"
                [virtualScrollItemSize]="34" (onKeyUp)="onEnter($event)" (completeMethod)="onFiltering($event)"
                (onSelect)="onChangeSearch1($event)" (onClear)="onChangeSearch1($event)" field="value"
                emptyMessage="No records found." [style]="{'width':'340px','text-align':'start'}"
                [inputStyle]="{'height':'37px', 'width':'100%'}" placeholder="Find by Name/Category">
                <ng-template let-group pTemplate="group">
                  <div class="flex align-items-center">
                    <span>{{ group.label }}</span>
                  </div>
                </ng-template>
              </p-autoComplete>
              <span class="right_searchIcon">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M14.9536 14.9458L21 21M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
                    stroke="#555" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="no-gutters exps-tab">


      <div class="tabs-block">
        <div>
          <a class="exp-tabs-item" [ngClass]="(is_booking==0) ? 'active' : ' '" (click)="tab_change(0)"
            href="javascript:void(0);">Buy as Voucher</a>
        </div>
        <div>
          <a class="exp-tabs-item" [ngClass]="(is_booking==1) ? 'active' : ' '" href="javascript:void(0)"
            (click)="tab_change(1)">Instant Book a Day/Time</a>
        </div>
        <div>
          <a class="exp-tabs-item" [ngClass]="(is_booking==2) ? 'active' : ' '" href="javascript:void(0)"
            (click)="tab_change(2)">Event Tickets</a>
        </div>
      </div>

      <div class="view-map text-center col-12 mxUnseRadioLabel" *ngIf="enable_rfp_225">

        <div class="viewCustomCheck">
          <label for="viewMap"> View on map</label>
          <input type="checkbox" id="viewMap" [checked]="view_on_map" (click)="map_view($event)" hidden />
          <label for="viewMap" class="customCheckLable"><i class="fa fa-check"></i></label>
        </div>
        <div class="viewCustomCheck" *ngIf="is_booking==0 && !view_on_map">
          <label for="atHomeExp"> Include At-Home Experiences</label>
          <input type="checkbox" id="atHomeExp" [checked]="at_home" (click)="at_home_exp($event)" hidden />
          <label for="atHomeExp" class="customCheckLable"><i class="fa fa-check"></i></label>
        </div>
      </div>
      <div class="col-12" *ngIf="enable_rfp_255">
        <div *ngIf="snipLinks && snipLinks?.length > 0">
          <div *ngFor="let snip of snipLinks">
            <div *ngIf="snip.tab_type == is_booking">
              <div class="snip_links row" *ngIf="snip.description || snip.url">
                <span class="snip_description col-10" *ngIf="snip.description">{{snip.description}}</span>
                <span class="snip_url col-2 text-right" *ngIf="snip.url">
                  <a [ngClass]="[snip.link_type == 1 ? 'btn btn-primary' : '']" href="{{snip.url}}">{{snip.title}}</a>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="align-style-icon">
    <div *ngIf="gridView == true ; else listView ">
      <div class="container">
        <img class="mobile-view" src="./assets/images/list_view.svg" alt="grid" (click)="changeView()" />
      </div>
      <div class="container" *ngIf="is_booking==0 || is_booking==1">
        <div class="row" *ngIf="view_on_map!=true">
          <div class="col-6 mx-auto px-1 px-sm-2 px-md-2 col-md-4 col-lg-3" *ngIf="certificate_data && is_booking==0">
            <div class="interCard">
              <figure>
                <a href="javascript:void(0);">
                  <div class="product-image lazyload"
                    [attr.data-bg]="certificate_data.image_url ? certificate_data.image_url+'?height=600' : '../../../../assets/images/gift-exp.png'"
                    style="background-image:url('../../../../assets/images/loading.gif');">
                  </div>
                </a>

              </figure>
              <div class="card-inner-box">
                <div class="bottomDesInter">
                  <h2>
                    <a href="javascript:void(0);">
                      {{certificate_data.title}}
                    </a>
                  </h2>
                </div>

                <div class="firstCard-box">
                  <div class="rateHome">
                    ANY AMOUNT
                  </div>
                  <div class="btnInterCart" *ngIf="isBrowser">
                    <a class="m-0" href="javascript:void(0);" (click)="add_gift_certificate()">add to cart</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="result && result?.length > 0">
            <div class=" col-6 mx-auto px-1 px-sm-2 px-md-2 col-md-4 col-lg-3"
              *ngFor="let record of result,let i = index">
              <div #allExperiences [id]="i" class="interCard position-relative"
                [ngClass]="{'viewOptiondiv' : record.child_experiences && record.child_experiences.length > 0}">
                <div
                  *ngIf="!isUserLogin && record.child_experiences && record?.for_individual_price > 0 &&  record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0"
                  id="select_people_{{i}}" class="interCard select_people">
                  <h4 class="modal-headerTitle">Select People</h4>
                  <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_people_')">×</div>
                  <div class="person_count" *ngFor="let data of record?.book_quantity_options">
                    <a
                      (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,data);removeClass(i,'select_people_')">
                      For {{data?.qty}} {{ data?.value }}
                      <ng-container *ngIf="record?.alternate_quantity == 0">
                        ${{record.exp_price*data?.key}}
                      </ng-container>
                    </a>
                  </div>
                </div>
                <a href="javascript:void(0);" *ngIf="isUserLogin ; else elseblock">
                  <figure>
                    <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                      (click)="exp_detail($event,record.slug,i,'',record)">

                      <div class="product-image lazyload"
                        [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                        style="background-image:url('../../../../assets/images/loading.gif');">
                        <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                          *ngIf="record.experience_status_msg">
                          {{record.experience_status_msg}}
                        </h4>
                      </div>

                      <div class="add_registry_checkmark active"
                        *ngIf="record.child_experiences?.length == 0 && record.is_show_ckbx == 1 && isUserLogin">
                      </div>


                    </a>
                    <div class="product-hover"
                      *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">

                      <a [ngClass]="record.added_registry_type == 'experiences_join_us' ? 'buyforquick' : 'removeexpcouplequick'"
                        href="javascript:void(0);" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                        {{authUser.role_id == 4 || authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from
                        registry'}}
                      </a>

                      <a class="removeexpcouplequick" href="javascript:void(0);"
                        *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                        authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</a>

                      <!-- <a class="buyforquick" href="javascript:void(0);" *ngIf="record.experience_type == 1 && (record.is_registry_status == 0 || record.is_registry_status == 2) && record.additional_person_price > 0 && authUser.role_id ==1" (click)="addToRegistry(record.id,'experiences_join_us',i)">add with join us</a> -->
                      <a class="buyforquick" href="javascript:void(0);"
                        *ngIf="(record.experience_type <= 2 && (record.is_registry_status == 0) && (authUser.role_id == 4 || authUser.role_id == 5)) && 2<1"
                        (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax)">Add
                        to cart</a>
                    </div>

                  </figure>
                </a>
                <div class="exp_add_remove_click"
                  *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                  <div class="mobileAddRegistryImg"
                    *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                    (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                    <img src="assets/images/exp_add_image.png" class="">
                  </div>
                  <div class="mobileRemoveRegistryImg"
                    *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                    (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                    <img src="assets/images/exp_remove_image.png" class="">
                  </div>
                </div>
                <ng-template #elseblock>
                  <a href="javascript:void(0);">
                    <figure>
                      <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                        (click)="exp_detail($event,record.slug,i,'',record)">
                        <div class="product-image lazyload"
                          [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                          style="background-image:url('../../../../assets/images/loading.gif');">
                        </div>
                      </a>

                    </figure>
                  </a>
                </ng-template>
                <div class="card-inner-box">
                  <div class="bottomDesInter" routerLink="/experiences/{{record.slug}}"
                    (click)="exp_detail($event,record.slug,i,'',record)">
                    <h2>
                      <a href="javascript:void(0);">
                        {{record.title}}
                      </a>
                    </h2>
                    <span *ngIf="record?.city && record.city !== '' ">
                      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 14.5C10.5 11 12.5 8 12.5 6C12.5 4.80653 12.0259 3.66193 11.182 2.81802C10.3381 1.97411 9.19347 1.5 8 1.5C6.80653 1.5 5.66193 1.97411 4.81802 2.81802C3.97411 3.66193 3.5 4.80653 3.5 6C3.5 8 5.5 11 8 14.5Z"
                          stroke="#e85325" />
                        <path
                          d="M10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6Z"
                          stroke="#e85325" />
                      </svg>
                      {{record.city ? ''+record.city+'' : ''}}
                    </span>
                  </div>
                  <h3 *ngIf="record.experience_type == 1">
                    ${{record.exp_price && record.exp_price>0 ? (record.exp_price | priceFormat) : '00'}}<span>
                      &#123; {{record.price_label}}
                      &#125;</span></h3>
                      <h3 *ngIf="record.experience_type == 7">
                        @if(record?.exp_price > 0) {
                          ${{ record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                        } @else if (record?.regular_price > 0 || record?.regular_price !== '') {
                          ${{ record.regular_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                        } @else {
                          ${{ (record.exp_price == '') ? 0 : record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                        }
                      </h3>
                  <h3 *ngIf="record.experience_type == 2">ANY PRICE</h3>

                  <div *ngIf="record?.child_experiences && record?.child_experiences.length > 0">
                    <button class="viewOptionbtn" routerLink="/experiences/{{record?.slug}}"
                      (click)="exp_detail($event,record.slug,i,'',record)">
                      VIEW PRICING OPTION</button>
                  </div>
                  <div *ngIf="record.review_rating > 0">
                    <p-rating [(ngModel)]="record.review_rating" [readonly]="true" [stars]="5" [cancel]="false">
                      <ng-template pTemplate="onicon">
                        <i class="pi pi-star-fill" style="color: #e85325"></i>
                      </ng-template>
                      <ng-template pTemplate="officon">
                        <i class="pi pi-star" style="color: #e85325"></i>
                      </ng-template>
                    </p-rating>
                    <span class="rating-info">
                      ( {{record.review_rating}}
                      <span class="vertical-separator"></span>
                      {{record.reviews_count}} {{record.reviews_count === 1 ? 'Review' : 'Reviews'}} )
                    </span>
                  </div>
                  <div class="btnInterCart" *ngIf="isBrowser">                    
                    @if(!isUserLogin && is_booking !== 1 &&  (!record?.for_individual_price || record?.for_individual_price == 0) &&
                    record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && 
                    record.instant_book==0) {
                      <a href="javascript:void(0);" (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,2)">add to cart</a>
                    } @else if (is_booking !== 1 && record?.for_individual_price > 0 && !isUserLogin && 
                    record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 &&
                     record.instant_book == 0){
                      <a href="javascript:void(0)" (click)="addCartQuantity(i,record,'select_people_')">ADD TO CART</a>
                    } @else if(!isUserLogin && record.child_experiences && record?.child_experiences?.length == 0 &&
                    record.experience_type != 2 && record?.instant_book == 1){
                     <a href="javascript:void(0)" routerLink="/experiences/{{record.slug}}"
                     (click)="exp_detail($event,record.slug,i,'book_now')">see availability</a>                    
                   }
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
        <div *ngIf="isDataLoading ==  true && isRendering == true" class="d-flex justify-content-center">
          <div class="spinner-border loading-spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="eventList">
          <div class="empty_ticket_div" *ngIf="result?.length==0 && isDataLoading ==  false && isRendering == false">
            <span>Oops!</span>
            <p>No results found</p>
          </div>
        </div>
      </div>
    </div>
    <ng-template #listView>
      <div class="container">
        <img class="mobile-view" src="./assets/images/grid_view.svg" alt="list" (click)="changeView()" />
      </div>
      <div class="container" *ngIf="is_booking==0 || is_booking==1">
        <div class="row" *ngIf="view_on_map!=true">
          <div class=" fullWidth-cardBox col-12 mx-auto px-2 px-sm-2 px-md-3" *ngIf="certificate_data && is_booking==0">
            <div class="interCard">
              <figure>
                <a href="javascript:void(0);">
                  <div class="product-image lazyload"
                    [attr.data-bg]="certificate_data.image_url ? certificate_data.image_url+'?height=600' : '../../../../assets/images/gift-exp.png'"
                    style="background-image:url('../../../../assets/images/loading.gif');">
                  </div>
                </a>

              </figure>
              <div class="card-inner-box">
                <div class="bottomDesInter">
                  <h2>
                    <a href="javascript:void(0);">
                      {{certificate_data.title}}
                    </a>
                  </h2>
                </div>
                <div class="rateHome">
                  ANY AMOUNT
                </div>
                <div class="btnInterCart" *ngIf="isBrowser">
                  <a href="javascript:void(0);" (click)="add_gift_certificate()">add to cart</a>
                </div>
              </div>
            </div>
          </div>
          
          <ng-container *ngIf="result && result?.length > 0">
            <div class=" fullWidth-cardBox col-12 mx-auto px-2 px-sm-2 px-md-3"
              *ngFor="let record of result,let i = index">
              <div #allExperiences [id]="i" class="interCard position-relative"
                [ngClass]="{'viewOptiondiv' : record.child_experiences && record.child_experiences.length > 0}">
                <div
                  *ngIf="!isUserLogin && record.child_experiences && record?.for_individual_price > 0 &&  record.child_experiences.length == 0 && record.experience_type != 2 && record.instant_book==0"
                  id="select_people_{{i}}" class="interCard select_people">
                  <h4 class="modal-headerTitle">Select People</h4>
                  <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_people_')">×</div>
                  <div class="person_count" *ngFor="let data of record?.book_quantity_options">
                    <a
                      (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,data);removeClass(i,'select_people_')">
                      For {{data?.qty}} {{ data?.value }}
                      <ng-container *ngIf="record?.alternate_quantity == 0">
                        ${{record.exp_price*data?.key}}
                      </ng-container>
                    </a>
                  </div>
                </div>
                <a href="javascript:void(0);" *ngIf="isUserLogin ; else elseblock1">
                  <figure>
                    <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                      (click)="exp_detail($event,record.slug,i,'',record)">

                      <div class="video-block" *ngIf="record?.cover_video != ''; else imageBlock">
                        <video *ngIf="record?.cover_video != null" #videoElement width="100%" id="exp-video"
                          class="video-playing embed-responsive-item" loop muted playsinline
                          onloadedmetadata="this.muted = true" [poster]="record?.image_url">
                          <source [src]="record?.cover_video" type="video/mp4" />
                        </video>
                        <div class="lazyload">
                          <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                            *ngIf="record.child_experiences?.length == 0 && record.experience_status_msg != ''">
                            {{record.experience_status_msg}}
                          </h4>
                        </div>
                      </div>
                      <ng-template #imageBlock>
                        <div class="product-image lazyload"
                          [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                          style="background-image:url('../../../../assets/images/loading.gif');">
                          <h4 class="received_viewCount" [ngClass]="record.add_reg_msg_class"
                            *ngIf="record.experience_status_msg">
                            {{record.experience_status_msg}}
                          </h4>
                        </div>
                      </ng-template>

                      <div class="add_registry_checkmark active"
                        *ngIf="record.child_experiences?.length == 0 && record.is_show_ckbx == 1 && isUserLogin">
                      </div>

                    </a>
                    <div class="product-hover"
                      *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">

                      <a [ngClass]="record.added_registry_type == 'experiences_join_us' ? 'buyforquick' : 'removeexpcouplequick'"
                        href="javascript:void(0);" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                        {{authUser.role_id == 4 || authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from
                        registry'}}
                      </a>

                      <a class="removeexpcouplequick" href="javascript:void(0);"
                        *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                        (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                        authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</a>

                      <!-- <a class="buyforquick" href="javascript:void(0);" *ngIf="record.experience_type == 1 && (record.is_registry_status == 0 || record.is_registry_status == 2) && record.additional_person_price > 0 && authUser.role_id ==1" (click)="addToRegistry(record.id,'experiences_join_us',i)">add with join us</a> -->
                      <a class="buyforquick" href="javascript:void(0);"
                        *ngIf="(record.experience_type <= 2 && (record.is_registry_status == 0) && (authUser.role_id == 4 || authUser.role_id == 5)) && 2<1"
                        (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax)">Add
                        to cart</a>
                    </div>
                  </figure>
                </a>
                <div class="exp_add_remove_click"
                  *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                  <div class="mobileAddRegistryImg"
                    *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                    (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                    <img src="assets/images/exp_add_image.png" class="">
                  </div>
                  <div class="mobileRemoveRegistryImg"
                    *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                    (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                    <img src="assets/images/exp_remove_image.png" class="">
                  </div>
                </div>
                <ng-template #elseblock1>
                  <a href="javascript:void(0);">
                    <figure>
                      <a href="javascript:void(0);" routerLink="/experiences/{{record.slug}}"
                        (click)="exp_detail($event,record.slug,i,'',record)">

                        <div *ngIf="record?.cover_video != ''; else imageBlockNew">
                          <video *ngIf="record?.cover_video != null" #videoElement width="100%" id="exp-video"
                            class="video-playing embed-responsive-item" loop muted playsinline
                            onloadedmetadata="this.muted = true" [poster]="record?.image_url">
                            <source [src]="record?.cover_video" type="video/mp4" />
                          </video>
                        </div>
                        <ng-template #imageBlockNew>
                          <div class="product-image lazyload"
                            [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
                            style="background-image:url('../../../../assets/images/loading.gif');">
                          </div>
                        </ng-template>
                      </a>
                    </figure>
                  </a>
                </ng-template>

                <div class="card-inner-box">
                  <div class="bottomDesInter" routerLink="/experiences/{{record.slug}}"
                    (click)="exp_detail($event,record.slug,i,'',record)">
                    <h2>
                      <a href="javascript:void(0);">
                        {{record.title}}
                      </a>
                    </h2>
                    <span *ngIf="record?.city && record.city !== '' ">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M8 14.5C10.5 11 12.5 8 12.5 6C12.5 4.80653 12.0259 3.66193 11.182 2.81802C10.3381 1.97411 9.19347 1.5 8 1.5C6.80653 1.5 5.66193 1.97411 4.81802 2.81802C3.97411 3.66193 3.5 4.80653 3.5 6C3.5 8 5.5 11 8 14.5Z"
                          stroke="#e85325" />
                        <path
                          d="M10 6C10 6.53043 9.78929 7.03914 9.41421 7.41421C9.03914 7.78929 8.53043 8 8 8C7.46957 8 6.96086 7.78929 6.58579 7.41421C6.21071 7.03914 6 6.53043 6 6C6 5.46957 6.21071 4.96086 6.58579 4.58579C6.96086 4.21071 7.46957 4 8 4C8.53043 4 9.03914 4.21071 9.41421 4.58579C9.78929 4.96086 10 5.46957 10 6Z"
                          stroke="#e85325" />
                      </svg>
                      {{record.city ? ''+record.city+'' : ''}}
                    </span>
                  </div>
                  <h3 *ngIf="record.experience_type == 1">
                    ${{record.exp_price && record.exp_price > 0 ? (record.exp_price | priceFormat) : '00'}}<span>
                      &#123; {{record.price_label}}
                      &#125;</span></h3>
                  <h3 *ngIf="record.experience_type == 7">
                    @if(record?.exp_price > 0) {
                      ${{ record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    } @else if (record?.regular_price > 0 || record?.regular_price !== '') {
                      ${{ record.regular_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    } @else {
                      ${{ (record.exp_price == '') ? 0 : record.exp_price }} <span> &#123; {{record.price_label}}  &#125;</span>
                    }
                    </h3>
                  <h3 *ngIf="record.experience_type == 2">ANY PRICE</h3>

                  <div *ngIf="record.child_experiences && record.child_experiences.length > 0">
                    <button class="viewOptionbtn" routerLink="/experiences/{{record.slug}}"
                      (click)="exp_detail($event,record.slug,i,'',record)">
                      VIEW PRICING OPTION</button>
                  </div>
                  <div *ngIf="record.review_rating > 0">
                    <p-rating [(ngModel)]="record.review_rating" [readonly]="true" [stars]="5" [cancel]="false">
                      <ng-template pTemplate="onicon">
                        <i class="pi pi-star-fill" style="color: #e85325"></i>
                      </ng-template>
                      <ng-template pTemplate="officon">
                        <i class="pi pi-star" style="color: #e85325"></i>
                      </ng-template>
                    </p-rating>
                    <span class="rating-info">
                      ( {{record.review_rating}}
                      <span class="vertical-separator"></span>
                      {{record.reviews_count}} {{record.reviews_count === 1 ? 'Review' : 'Reviews'}} )
                    </span>
                  </div>
                  <div class="btnInterCart" *ngIf="isBrowser">
                    @if(!isUserLogin && is_booking !== 1 &&  (!record?.for_individual_price || record?.for_individual_price == 0) &&
                    record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 && 
                    record.instant_book==0) {
                      <a href="javascript:void(0);" (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,2)">
                        add to cart</a>
                    } @else if (is_booking !== 1 && record?.for_individual_price > 0 && !isUserLogin && 
                    record.child_experiences && record.child_experiences.length == 0 && record.experience_type != 2 &&
                     record.instant_book == 0){
                      <a href="javascript:void(0)" (click)="addCartQuantity(i,record,'select_people_')">ADD TO CART</a>
                    } @else if (is_booking !== 1 && record.experience_type == 2) {
                      <a href="javascript:void(0);" (click)="add_gift_event(record)">add to cart</a>
                    } @else if(!isUserLogin && record.child_experiences && record?.child_experiences?.length == 0 &&
                       record.experience_type != 2 && record?.instant_book == 1){
                        <a href="javascript:void(0)" routerLink="/experiences/{{record.slug}}"
                        (click)="exp_detail($event,record.slug,i,'book_now')">see availability</a>                    
                    }
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

        </div>
        <div *ngIf="isDataLoading ==  true && isRendering == true" class="d-flex justify-content-center">
          <div class="spinner-border loading-spinner" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="eventList">
          <div class="empty_ticket_div" *ngIf="result?.length==0 && isDataLoading ==  false && isRendering == false">
            <span>Oops!</span>
            <p>No results found</p>
          </div>
        </div>
      </div>
    </ng-template>
  </div>


  <!-- event section start -->
  <div class="eventList" *ngIf="is_booking==2">
    <ng-container *ngIf="!view_on_map && result && result?.length > 0">
      <div class="container">
        <div class="row eventBlock_head align-items-center" *ngFor="let data of result">
          <div class="col-12 col-md-2 px-0">
            <div class="eventDate">
              <h5>{{data.day_name}}</h5>
              <h6>{{data.event_date}}</h6>
            </div>
          </div>
          <div class="col-12 col-md-8 text-center text-md-left px-0">
            <div class="eventInfo">
              <div><a [routerLink]="['/vebo-seats']" [queryParams]="{'event_id': data.event_id}">{{data.event_name}}</a>
              </div>
              <span>{{data.event_time}} - {{data.venue_name}}, {{data.venue_location}}</span>
            </div>
          </div>
          <div class="col-12 col-md-2 px-0 text-center text-md-right">
            <div class="tkt_End">
              <span>from</span>
              <div class="tkt_end_day">
                {{data.min_price!='$null' && data.min_price!='$0.00' ? data.min_price : 'NA' }} <span>(All-In
                  Price)</span>
              </div>
              <span>{{data.available_count}} tickets left</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="view_on_map">
      <div id="mapParent" class="row ml-0">
        <div class="col-12 order-1 order-lg-0 col-lg-6 mapListBg">
          <ng-container *ngIf="result && result.length > 0">
            <div class="row mapCard eventBlock_head mx-0 align-items-center" (mouseenter)="map_image_enter(i)"
              (mouseleave)="map_image_out(i)"
              *ngFor="let data of result | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: totalRecord } ,let i = index">
              <div class="col-12 col-md-2 px-0">
                <div class="eventDate">
                  <h5>{{data.day_name}}</h5>
                  <h6>{{data.event_date}}</h6>
                </div>
              </div>
              <div class="col-12 col-md-8 text-center text-md-left px-0">
                <div class="eventInfo">
                  <div><a [routerLink]="['/vebo-seats']"
                      [queryParams]="{'event_id': data.event_id}">{{data.event_name}}</a>
                  </div>
                  <span>{{data.event_time}} - {{data.venue_name}}, {{data.venue_location}}</span>
                </div>
              </div>
              <div class="col-12 col-md-2 px-0 text-center text-md-right">
                <div class="tkt_End">
                  <span>from</span>
                  <div class="tkt_end_day">
                    {{data.min_price!='$null' && data.min_price!='$0.00' ? data.min_price : 'NA' }} <span>(All-In
                      Price)</span>
                  </div>
                  <span>{{data.available_count}} tickets left</span>
                </div>
              </div>
            </div>
            <div class="paginationMap">
              <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
            </div>
          </ng-container>
          <div class="empty_ticket_div" *ngIf="result?.length==0"><span>Oops!</span>
            <p>No results found</p>
          </div>
        </div>
        <div class="map-view col-12 pb-3 pb-lg-0 order-0 order-lg-1  col-lg-6 px-0 pr-lg-0">
          <div class="searchMapLocation">
            <div *ngIf="search_with_map">
              <input type="checkbox" id="agMapSearch" [checked]="search_with_map" (click)="searchWithMap(0)" hidden />
              <label class="agSearchcheckbox" for="agMapSearch">Search as I move the map</label>
            </div>
            <div class="searchAreaMap" *ngIf="!search_with_map" (click)="searchWithMap(1)">
              <i class="fal fa-redo-alt pr-2"></i> Search this area
            </div>
          </div>

        </div>
      </div>
    </ng-container>
    <div class="empty_ticket_div" *ngIf="result?.length==0 && !view_on_map"><span>Oops!</span>
      <p>No results found</p>
    </div>
  </div>
  <!-- event section end -->

  <div #boundary class="container-fluid" id="mapParent" *ngIf="is_booking == 0 || is_booking == 1">
    <div class="row" *ngIf="view_on_map && enable_rfp_225">
      <div class="col-12 order-1 order-lg-0 col-lg-6 mapListBg">
        <div class="scrollMap_viewing for d-lg-none">
          <div class="scrMap_viewContent">300+ places to stay</div>
        </div>

        <ng-container *ngIf="result && result.length > 0">

          <div class="mapCard" (mouseenter)="map_image_enter(i)" (mouseleave)="map_image_out(i)"
            *ngFor="let record of result | paginate: {itemsPerPage: pageSize,currentPage: page,totalItems: totalRecord } ,let i = index">
            <div class="mapCardimg lazyload"
              [attr.data-bg]="(record.image_url == '') ? 'assets/images/vebo_find_img.png' : record.image_url+'?height=600'"
              style="background-image:url('../../../../assets/images/loading.gif');">
              <a *ngIf="isUserLogin && record.experience_status_msg != ''" href="javascript:void(0);"
                (click)="exp_detail($event,record.slug,i,'',record)" [ngClass]="record.add_reg_msg_class">
                {{record.experience_status_msg}}
              </a>

              <div class="exp_add_remove_click"
                *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                <div class="mobileAddRegistryImg"
                  *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                  <img src="assets/images/exp_add_image.png" class="">
                </div>
                <div class="mobileRemoveRegistryImg"
                  *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">
                  <img src="assets/images/exp_remove_image.png" class="">
                </div>
              </div>

            </div>
            <div class="mapCardcontnet map_btn position-relative">

              <div *ngIf="record.experience_type == 1" id="select_map_people_{{i}}" class="interCard select_map_people">
                <h4 class="modal-headerTitle">Select People</h4>
                <div class="cartpopup_removecart closeBtn" (click)="removeClass(i,'select_map_people_')">×</div>
                <div class="person_count" *ngFor="let data of record?.book_quantity_options"
                  (click)="openDialog(record,record.exp_price,'buy-for-yourself',record.sales_tax,data);removeClass(i,'select_map_people_')">
                  For {{data?.qty}} {{ data?.value }}
                  <ng-container *ngIf="record?.alternate_quantity == 0">
                    ${{record.exp_price*data?.key}}
                  </ng-container>
                </div>
              </div>
              <div class="mapCardTitle"><a href="javascript:void(0);"
                  (click)="exp_detail($event,record.slug,i,'',record)">{{record.title}}</a></div>
              <div class="mapCompnyName">
                <div *ngIf="record.experience_type == 1">{{record?.company_name}}</div>
              </div>
              <div class="mapCompnyAddress"><i class="fas fa-map-marker-alt pr-1"></i> {{record.city}} {{record.state}}
              </div>
              <div *ngIf="!isUserLogin && record.experience_type == 2 && isBrowser">
                <button class="themeBtn" *ngIf="1>2">Buy as gift</button>
                <button class="themeBtn" [routerLink]="['/ticket-category']">Browse tickets</button>
                <button class="themeBtn" (click)="add_gift_event(record)">Add to cart</button>
              </div>
              <div
                *ngIf="isUserLogin && record.experience_status <= 1 && record.child_experiences?.length == 0 && (authUser.role_id == 1 || authUser.role_id == 4 || authUser.role_id == 5)">
                <button class="themeBtn" *ngIf="record.experience_type <= 2 && record.is_registry_status == 1"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                  authUser.role_id == 5 ? 'Remove from Bucket List' : 'Remove from registry'}}</button>
                <button class="themeBtn"
                  *ngIf="record.experience_type <= 2 && (record.is_registry_status == 0 || record.is_registry_status == 2)"
                  (click)="addToRegistry(record.id,'experiences_class_for_couple',i)">{{authUser.role_id == 4 ||
                  authUser.role_id == 5 ? 'Add to Bucket List' : 'Add to registry'}}</button>
              </div>
              <button class="themeBtn" (click)="addCartQuantity(i,record,'select_map_people_')"
                *ngIf="!isUserLogin && record?.for_individual_price > 0 && record.experience_type == 1">Add to
                cart</button>

              <!-- <button class="themeBtnRed" (click)="exp_detail($event,record.slug,i,'book_now',record)"
                *ngIf="record.instant_book==1">see availability</button> -->

              <div class="startingPrice" *ngIf="record.instant_book==1">
                <svg x="0px" y="0px" viewBox="0 0 27.793 27.793" style="height:18px; fill:#666;">
                  <polygon points="20.972,0 5.076,15.803 10.972,15.803 6.44,27.793 22.716,11.989 16.819,11.989" />
                </svg> Instant Book
              </div>
              <div class="mapReviewPrice">
                <div class="mapReview">
                  <div [attr.data-bv-show]="'inline_rating'" [attr.data-bv-product-id]="record.id"
                    *ngIf="record.bv_reviews_count > 0"></div>
                </div>
                <div class="mapPrice" *ngIf="record.experience_type == 1">
                  <i class="far fa-dollar-sign pr-1"></i>{{record.exp_price | priceFormat }}
                  <span>/{{record.price_label}}</span>
                </div>
                <div class="mapPrice" *ngIf="record.experience_type == 2">
                  <span>Any price</span>
                </div>
              </div>
            </div>
          </div>
          <div class="paginationMap">
            <pagination-controls (pageChange)="pageChanged($event)"></pagination-controls>
          </div>

        </ng-container>
        <div *ngIf="result && result.length == 0">
          <div class="text-center">No experiences found at this location</div>
        </div>
      </div>

      <div stickyThing [boundary]="boundary" marginTop="70"
        class="map-view col-12 pb-3 pb-lg-0 order-0 order-lg-1  col-lg-6 px-0 pr-lg-0" id="stickyMap">
        <google-map #googleMap [mapId]="mapContFix" [width]="600" [height]="550" [streetView]="true"
          [center]="{ lat: +result[0]?.latitude , lng: +result[0]?.longitude }" [options]="mapOptions">
          <!-- (mapDragend)="search_with_map ?searchWithMap(1): '' " -->
          <map-marker #marker="mapMarker" *ngFor="let record of result;let i = index" [id]="'marker_'+i"
            [icon]="record?.map_image" [zIndex]="record?.zindex" [gmpClickable]="true"
            (mapClick)="onMouseClick(i, marker,infoWindow)"
            [position]="{ lat: +record?.latitude , lng: +record?.longitude }">
            <map-info-window #infoWindow="mapInfoWindow" (closeclick)="infoWindowClose(infoWindow)">
              <br><br>
              <owl-carousel-o [options]="owlExpDetail">
                <ng-template carouselSlide [width]="250" *ngFor="let gallery of record.gallery_list" [id]="gallery.id">
                  <a (click)="exp_detail($event,record.slug,i,'',record)">
                    <div class="item">
                      <div class="mapItemOwlBack lazyload"
                        [attr.data-bg]="(gallery.image != '') ? gallery.image : '../../../assets/images/loading.gif'"
                        style="background-image: url('assets/images/loading.gif');">
                        <img class="lazyload"
                          [attr.data-src]="(gallery.image != '') ? gallery.image : '../../../assets/images/loading.gif'"
                          alt="" src="../../../../assets/images/loading.gif">
                      </div>
                    </div>
                  </a>
                </ng-template>
              </owl-carousel-o>
              <div class="mapWindoParant">
                <div class="mapReview mapReviewRecord" *ngIf="record.bv_reviews_count > 0">
                  <div [attr.data-bv-show]="'inline_rating'" [attr.data-bv-product-id]="record.id"></div>
                </div>
                <p class="maprecordTitle" (click)="exp_detail($event,record.slug,i,'',record)">{{record.title}}</p>
                <p class="mapRecordRate" *ngIf="record.experience_type == 1">
                  ${{record.regular_price | priceFormat }}<span> /{{record.price_label}}</span></p>
                <p class="mapRecordRate" *ngIf="record.experience_type == 2"><span>Any price</span></p>
              </div>
            </map-info-window>
          </map-marker>
        </google-map>

        <div class="searchMapLocation">
          <div *ngIf="search_with_map">
            <input type="checkbox" id="agMapSearch" [checked]="search_with_map" (click)="searchWithMap(0)" hidden />
            <label class="agSearchcheckbox" for="agMapSearch">Search as I move the map</label>
          </div>
          <div class="searchAreaMap" *ngIf="!search_with_map" (click)="searchWithMap(1)">
            <i class="fal fa-redo-alt pr-2"></i> Search this area
          </div>
        </div>

      </div>
    </div>
  </div>
</div>


<!-- Modal -->
<div class="modal fade" id="homeModalFilter" tabindex="-1" role="dialog" aria-labelledby="homeModalFilterLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-fullscreen" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            <svg width="22" height="22" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 21.32L21 3.32001" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M3 3.32001L21 21.32" stroke="#000000" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <div class="home_searchInner home_searchInner_mobile">
          <div class="search_placeBox">
            <label class="search_placeLable">Where To?</label>
            <div class="input_boxSearch">
              <div class="primeAutocomplete homeAutoCompCountryParent homeSerachWidth">
                <p-autoComplete #autoCompleteRef emptyMessage="No records found." (onClear)="clear_searched_data()"
                  [suggestions]="autocompleteExpResults" (completeMethod)="autocompleteSearchData($event)"
                  placeholder="{{title_search ? title_search : 'Search for a place or experience'}}"
                  (onSelect)="onSelectAutocompleteSearch($event.value, true);" field="label"
                  (onFocus)="onFocusSearchBox($event)" (onBlur)="onBlurSearchBox($event)"
                  (input)="searchedInput($event)" [style]="{'width':'100%'}"
                  [inputStyle]="{'width':'100%'}" id="autoCompleteSearchValueMobile">
                  <ng-template let-country pTemplate="item">
                    <div class="country-item homeCountyAutoComplete">
                      <div class="location-icons-photo">
                        @if(country?.type == 'location'){
                        <img [src]="country?.image_url" class="flag" />
                        }

                        <img *ngIf="country?.type == 'exp' || country?.type == 'category'"
                          [src]="(country?.type == 'exp') ? exp_image_url + country?.image : ((country?.type == 'category') ? category_image_url + country?.image : location_image_url + country.image )"
                          class="flag" />
                      </div>

                      <div class="countryLabelHomeparent text-left">
                        <div class="countryLabelHome">{{country?.label}}</div>
                        <div class="countryLabelAddress" *ngIf="country?.type == 'exp'">
                          {{country?.city_name}} , {{country?.state_name}}
                        </div>
                        <div class="countryLabelprice" *ngIf="country.type == 'location'">
                          <span>(Location)</span>
                        </div>
                        <div class="countryLabelprice" *ngIf="country?.type == 'exp' && country?.experience_type == 1">
                          ${{country?.exp_price | priceFormat}}
                          <span>
                            &#123; {{country?.price_label}} &#125;
                          </span>
                        </div>
                        <div class="countryLabelprice" *ngIf="country?.type == 'exp' && country?.experience_type == 2">
                          ANY PRICE
                        </div>
                      </div>

                    </div>
                  </ng-template>
                </p-autoComplete>

                <!-- Recent searches dropdown -->
                <div class="recent-searches-dropdown" *ngIf="showRecentSearches">
                  <ul>
                    <li (click)="nearby(true)">
                      <div class="location-icons-photo">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                          width="512" height="512" x="0" y="0" viewBox="0 0 32 32"
                          style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                          <g>
                            <path
                              d="M28.707 3.293a.997.997 0 0 0-1.123-.202l-24 11a1 1 0 0 0 .333 1.906l11.157.93.93 11.156a1 1 0 0 0 1.906.334l11-24a1 1 0 0 0-.203-1.124zM17.68 24.117l-.683-8.2a1 1 0 0 0-.914-.914l-8.2-.683L25.97 6.03z"
                              fill="#000000" opacity="1" data-original="#000000" class="">
                            </path>
                          </g>
                        </svg>

                      </div>
                      <div class="locationName">
                        Nearby
                      </div>
                    </li>
                  </ul>

                  <div class="search-reset" *ngIf="searchHistory?.length">
                    <div class="recents">Recent Searches</div>
                    <div class="recents-clear"><a (click)="clearRecentSearch()" href="javascript:void(0)">Clear</a>
                    </div>
                  </div>
                  <ul *ngIf="searchHistory?.length">
                    <ul>
                      <li *ngFor="let search of searchHistory" (click)="selectRecentSearch(search, true);">
                        <div class="location-icons-photo">
                          <svg *ngIf="search?.type == 'location-list'" width="23" height="29" viewBox="0 0 23 29"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M20.2188 11.5938C20.2187 9.28139 19.3002 7.06375 17.6651 5.42866C16.03 3.79358 13.8124 2.875 11.5 2.875C9.18764 2.875 6.97 3.79358 5.33491 5.42866C3.69983 7.06375 2.78125 9.28139 2.78125 11.5938C2.78125 15.1704 5.64294 19.832 11.5 25.4159C17.3571 19.832 20.2188 15.1704 20.2188 11.5938ZM11.5 28.0625C4.39519 21.6048 0.84375 16.1139 0.84375 11.5938C0.84375 8.76754 1.96646 6.05708 3.96489 4.05864C5.96333 2.06021 8.67379 0.9375 11.5 0.9375C14.3262 0.9375 17.0367 2.06021 19.0351 4.05864C21.0335 6.05708 22.1562 8.76754 22.1562 11.5938C22.1562 16.1139 18.6048 21.6048 11.5 28.0625Z"
                              fill="black" />
                            <path
                              d="M11.5 14.5C12.2708 14.5 13.01 14.1938 13.555 13.6488C14.1001 13.1038 14.4062 12.3645 14.4062 11.5938C14.4062 10.823 14.1001 10.0837 13.555 9.53872C13.01 8.99369 12.2708 8.6875 11.5 8.6875C10.7292 8.6875 9.99 8.99369 9.44497 9.53872C8.89994 10.0837 8.59375 10.823 8.59375 11.5938C8.59375 12.3645 8.89994 13.1038 9.44497 13.6488C9.99 14.1938 10.7292 14.5 11.5 14.5ZM11.5 16.4375C10.2154 16.4375 8.98333 15.9272 8.07495 15.0188C7.16657 14.1104 6.65625 12.8784 6.65625 11.5938C6.65625 10.3091 7.16657 9.07708 8.07495 8.1687C8.98333 7.26032 10.2154 6.75 11.5 6.75C12.7846 6.75 14.0167 7.26032 14.925 8.1687C15.8334 9.07708 16.3438 10.3091 16.3438 11.5938C16.3438 12.8784 15.8334 14.1104 14.925 15.0188C14.0167 15.9272 12.7846 16.4375 11.5 16.4375Z"
                              fill="black" />
                          </svg>

                          <img [src]="search.image_url" *ngIf="search?.type == 'exp'" class="img-fluid search-img" />
                          <img [src]="search.image_url" *ngIf="search?.type == 'higher-level-category'" class="img-fluid search-img" />
                          <svg width="800px" *ngIf="search?.type == 'category'" height="800px" viewBox="0 0 24 24"
                            id="_24x24_On_Light_Recent" data-name="24x24/On Light/Recent"
                            xmlns="http://www.w3.org/2000/svg">
                            <rect id="view-box" width="24" height="24" fill="none" />
                            <path id="Shape"
                              d="M9.682,18.75a.75.75,0,0,1,.75-.75,8.25,8.25,0,1,0-6.189-2.795V12.568a.75.75,0,0,1,1.5,0v4.243a.75.75,0,0,1-.751.75H.75a.75.75,0,0,1,0-1.5H3a9.75,9.75,0,1,1,7.433,3.44A.75.75,0,0,1,9.682,18.75Zm2.875-4.814L9.9,11.281a.754.754,0,0,1-.22-.531V5.55a.75.75,0,1,1,1.5,0v4.889l2.436,2.436a.75.75,0,1,1-1.061,1.06Z"
                              transform="translate(1.568 2.25)" fill="#141124" />
                          </svg>
                        </div>
                        <div class="location-infos">
                          <span class="product-name">{{search?.title}}
                          </span><br>
                          <span class="cityName">{{search?.city ?
                            '('+search?.city+')' : ''}}</span>
                        </div>

                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="search_placeBox">

            <!-- this is for open date picker => [isOpen]="isOpenDatePicker" -->
            <label class="search_placeLable">When? (optional) </label>
            <div class="input_boxSearch">
              <div class="selectDataBlock" *ngIf="isMobile">
                <input type="text" bsDaterangepicker placeholder="" [dateCustomClasses]="dateCustomClasses"
                  placement="bottom left" [outsideClick]="true" class="date_pickerFont"
                  [bsConfig]="{showWeekNumbers:false, dateInputFormat: 'MM/DD/YYYY',displayMonths :1}"
                  [minDate]="minDate" [maxDate]="maxDate" placeholder="Select dates"
                  (bsValueChange)="chooseMethodTocall($event)" (onShown)="onShowPicker($event)" readonly="readonly"
                  [(ngModel)]="selectedDateRange" />
                <a class="dataClear" (click)="clearDate()" *ngIf="selectedDateRange?.length"
                  href="javascript:void(0); ">
                  <svg width="10" height="10" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M3.8125 3.81227C4.04691 3.57793 4.36479 3.44629 4.69625 3.44629C5.02771 3.44629 5.34559 3.57793 5.58 3.81227L10 8.23227L14.42 3.81227C14.6558 3.58457 14.9715 3.45858 15.2993 3.46143C15.627 3.46428 15.9405 3.59574 16.1723 3.8275C16.404 4.05926 16.5355 4.37277 16.5383 4.70052C16.5412 5.02827 16.4152 5.34402 16.1875 5.57977L11.7675 9.99977L16.1875 14.4198C16.4152 14.6555 16.5412 14.9713 16.5383 15.299C16.5355 15.6268 16.404 15.9403 16.1723 16.172C15.9405 16.4038 15.627 16.5353 15.2993 16.5381C14.9715 16.541 14.6558 16.415 14.42 16.1873L10 11.7673L5.58 16.1873C5.34425 16.415 5.02849 16.541 4.70075 16.5381C4.373 16.5353 4.05949 16.4038 3.82773 16.172C3.59597 15.9403 3.46451 15.6268 3.46166 15.299C3.45881 14.9713 3.5848 14.6555 3.8125 14.4198L8.2325 9.99977L3.8125 5.57977C3.57816 5.34536 3.44652 5.02748 3.44652 4.69602C3.44652 4.36457 3.57816 4.04668 3.8125 3.81227Z"
                      fill="#25324B" />
                  </svg>

                </a>
              </div>
            </div>
          </div>
          <div class="search_homeBtn">
            <button class="primeSeachBox prime_active"
              (click)="onSelectAutocompleteLocation(autocomplete_search_to, true)" data-dismiss="modal"
              aria-label="Close">
              <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="search" role="img"
                xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-search fa-w-16">
                <path fill="#fff"
                  d="M508.5 481.6l-129-129c-2.3-2.3-5.3-3.5-8.5-3.5h-10.3C395 312 416 262.5 416 208 416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c54.5 0 104-21 141.1-55.2V371c0 3.2 1.3 6.2 3.5 8.5l129 129c4.7 4.7 12.3 4.7 17 0l9.9-9.9c4.7-4.7 4.7-12.3 0-17zM208 384c-97.3 0-176-78.7-176-176S110.7 32 208 32s176 78.7 176 176-78.7 176-176 176z"
                  class=""></path>
              </svg>

              <span class="d-md-none">Search</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>